'use strict';
import { StringFilter } from './filters/string-filter';
import { BooleanFilter } from './filters/boolean-filter';
import { NumberFilter } from './filters/number-filter';
import { DateFilter } from './filters/date-filter';
import { SelectFilter } from './filters/select-filter';
import { PickupFilter } from './filters/pickup-filter';
import { GuidFilter } from './filters/guid-filter';
import { MxObjectPropertyType } from '../../../../Pandora/model/object';

export class MxGridColumnFiltersFactory {
	static $inject = ['mx.internationalization', 'mx.shell.Config', 'mx.sb.Agent.DataQuery.FilterOperatorsFactory'];

	constructor(i18n, configService, filterOperatorsFactory) {
		Object.assign(this, { i18n, configService, filterOperatorsFactory });
	}

	initColumnFilter(column) {
		let filter;
		const filterOptions = {
			column: column,
			i18n: this.i18n,
			configService: this.configService,
			filterOperatorsFactory: this.filterOperatorsFactory,
		};

		switch (column.AttributeValueType) {
			case MxObjectPropertyType.String.name:
			case MxObjectPropertyType.Text.name:
			case MxObjectPropertyType.Icon.name:
			case MxObjectPropertyType.Color.name:
				filter = new StringFilter(filterOptions);
				break;
			case MxObjectPropertyType.Boolean.name:
				filter = new BooleanFilter(filterOptions);
				break;
			case MxObjectPropertyType.Integer.name:
			case MxObjectPropertyType.Float.name:
			case MxObjectPropertyType.Long.name:
			case MxObjectPropertyType.Decimal.name:
			case MxObjectPropertyType.Currency.name:
				filter = new NumberFilter(filterOptions);
				break;
			case MxObjectPropertyType.Date.name:
				filter = new DateFilter(filterOptions);
				break;
			case MxObjectPropertyType.Guid.name:
				filter = new GuidFilter(filterOptions);
				break;
			default:
				filter = new StringFilter(filterOptions);
		}

		if (column.IsEnum) {
			filter = new SelectFilter(filterOptions);
		}

		if (column.IsPickup) {
			filter = new PickupFilter(filterOptions);
		}

		filter.init(column);

		return filter;
	}
}
